import React from "react";
import ClinicalReportSection from "./ClinicalReportSection";
import { healthDocumentConfig } from "./abhaClinicalConfigs";

const HealthDocumentSection = ({ patientId, patientData }) => (
  <ClinicalReportSection
    patientId={patientId}
    patientData={patientData}
    config={healthDocumentConfig}
  />
);

export default HealthDocumentSection;
